import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=9a182ad8"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports